<template>
  <b-modal id="helpModal" :title="$t('Shortcuts')" hide-footer>
    <table class="table table-sm">
      <tr v-for="(shortcut,index) in shortcuts" :key="shortcut.key">
        <th :class="index > 0 ? '' : 'border-top-0'">{{ shortcut.key }}</th>
        <td :class="index > 0 ? '' : 'border-top-0'">{{ shortcut.action }}</td>
      </tr>
    </table>
  </b-modal>
</template>
<script>
  export default {
    name: "ShortcutsModal",
    props: {
      shortcuts: {
        type: Array
      }
    }
  }
</script>

<style scoped></style>
